import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/seo-head";
import Blog from "@/pages/Blog";
import { supabase } from "@/integrations/supabase/client";

export const Route = createFileRoute("/blog/")({
  component: BlogIndexRoute,
  loader: async () => {
    const { data } = await supabase
      .from("blog_posts")
      .select("id, title, slug, excerpt, tags, published_at")
      .lte("published_at", new Date().toISOString())
      .order("published_at", { ascending: false })
      .limit(200);
    return {
      posts: (data ?? []).map((p) => ({
        ...p,
        tags: p.tags ?? [],
        published_at: p.published_at ?? "",
      })),
    };
  },
  head: () =>
    pageHead({
      title: "Contractor Marketing Blog | Seattle SEO Tips | jaik",
      description: "Contractor SEO, website design and lead generation guides for King County and Puget Sound trades. Practical advice from jaik.",
      path: "/blog",
    }),
});

function BlogIndexRoute() {
  const { posts } = Route.useLoaderData();
  return <Blog initialPosts={posts} />;
}
